import { assertNever } from '@willow/shared-web';
import { TOSVersion } from '@willow/types-iso';

import { TOSv1 } from './TOSv1';
import { TOSv2 } from './TOSv2';

export const VersionedTOS = ({ version }: { version: TOSVersion }) => {
  switch (version) {
    case 1:
      return <TOSv1 />;
    case 2:
      return <TOSv2 />;
    default:
      assertNever(version);
  }
};
